// extracted by mini-css-extract-plugin
module.exports = {"container":"_68a2e4aa","link":"_8acaeaad","icon":"_83bb3986"};